import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
  loginAction2,
  loginFailedAction,
} from "../../store/actions/AuthActions";
import axiosInstance from "../../services/AxiosInstance";

import loginbg from "../../images/login-bg.png";

import { useAuth, firebase } from "../../providers/use-auth";
import swal from "sweetalert";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

import { Spinner } from "react-bootstrap";

function Login(props) {
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "", phone: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");

  const [phone, setPhone] = useState("");
  const [otp, setotp] = useState("");
  const [showOtp, setshowOtp] = useState(false);
  const [final, setfinal] = useState("");

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const fAuth = useAuth();

  useEffect(() => {
    dispatch(loginFailedAction(null));
  }, [dispatch]);

  const onLogin = async (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));

    let response = await fAuth.signin(email, password);
    if (response.hasOwnProperty("message")) {
      dispatch(loadingToggleAction(false));
      dispatch(loginFailedAction(response.message));
      return;
    }

    if (response.hasOwnProperty("user")) {
      const idToken = await response.user.getIdToken(true);
      dispatch(
        loginAction(
          idToken,
          response.user.displayName,
          response.user.email,
          props.history
        )
      );
      return;
    }
  };

  function setuprecaptcha() {
    if (window.recaptchaVerifier) return;
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
        callback: (response) => {
          signin();
        },
      }
    );
  }

  const signin = (e) => {
    if (e) e.preventDefault();

    let error = false;
    const errorObj = { ...errorsObj };

    if (phone === "" || phone.length < 10) {
      errorObj.phone = "Phone Number is Required";
      error = true;
    }

    setErrors(errorObj);
    if (error) return;

    setLoading(true);

    axiosInstance
      .post("admin/send-otp", {
        auth_type: "phone",
        phone: phone,
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data;
        if (!data) {
          swal("Phone Login", response?.response?.data?.message || "Server error. Please try again.", "error");
          return;
        }
        if (data.status) {
          swal("Phone Login", "OTP sent to " + phone, "success");
          setshowOtp(true);
        } else {
          swal("Phone Login", data.message || "Failed to send OTP", "error");
        }
      })
      .catch((err) => {
        setLoading(false);
        swal("Phone Login", "Server error: " + err.message, "error");
      });
  };

  const ValidateOtp = (e) => {
    e.preventDefault();

    let error = false;
    const errorObj = { ...errorsObj };

    if (!otp) {
      errorObj.phone = "OTP is Required";
      error = true;
    }

    setErrors(errorObj);
    if (error) {
      return;
    }

    setLoading(true);
    axiosInstance
      .post("admin/verify-otp", {
        auth_type: "phone",
        phone: phone,
        otp: otp,
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data;
        if (!data) {
          swal("Phone Login", response?.response?.data?.message || "Server error. Please try again.", "error");
          return;
        }
        if (data.status) {
          dispatch(loginAction2(response, props.history));
        } else {
          swal("Phone Login", data.message || "Incorrect OTP", "error");
        }
      })
      .catch((err) => {
        setLoading(false);
        swal("Phone Login", "Server error: " + err.message, "error");
      });
  };

  return (
    <div className="" style={{ background: "#17556D" }}>
      <div
        className="login-main-page"
        style={{ backgroundImage: "url(" + loginbg + ")" }}
      >
        <div className="row justify-content-center align-items-center p-2" style={{ minHeight: "100vh" }}>
          <div className="col-md-4">
            <div className="card p-2" style={{ borderRadius: "8px" }}>
              <div className="text-center p-4">
                <img src={process.env.REACT_APP_LOGO} alt="" style={{ maxWidth: "150px" }} />
              </div>

              <div className="card-body">
                <div className="mb-4">
                  <h3 className="dz-title mb-1">Admin Login</h3>
                </div>

                {!showOtp ? (
                  <form onSubmit={signin} className="mt-4">
                    <div className="form-group">
                      <label className="mb-2"><strong>Phone Number</strong></label>
                      <PhoneInput
                        placeholder="Enter phone number"
                        value={phone}
                        defaultCountry="IN"
                        onChange={setPhone}
                      />
                      {errors.phone && <div className="text-danger fs-12">{errors.phone}</div>}
                    </div>

                    {props.errorMessage && (
                      <div className="alert alert-danger py-2 mt-2">
                        {props.errorMessage}
                      </div>
                    )}

                    <div className="text-center mt-4">
                      {loading ? (
                        <Spinner animation="border" variant="primary" />
                      ) : (
                        <button type="submit" className="btn btn-primary btn-block">Send OTP</button>
                      )}
                    </div>
                  </form>
                ) : (
                  <form onSubmit={ValidateOtp}>
                    <div className="form-group">
                      <Link className="text-primary" onClick={() => setshowOtp(false)}>Change Number</Link>
                      <label className="my-2 d-block"><strong>One Time Password</strong></label>
                      <input
                        type="number"
                        className="form-control"
                        value={otp}
                        onChange={(e) => setotp(e.target.value)}
                        placeholder="Enter OTP"
                      />
                      {errors.otp && <div className="text-danger fs-12">{errors.otp}</div>}
                    </div>

                    {props.errorMessage && (
                      <div className="alert alert-danger py-2 mt-2">
                        {props.errorMessage}
                      </div>
                    )}

                    <div className="text-center mt-4">
                      {loading ? (
                        <Spinner animation="border" variant="primary" />
                      ) : (
                        <button type="submit" className="btn btn-primary btn-block">Verify</button>
                      )}
                    </div>
                  </form>
                )}

                <div id="recaptcha-container"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  errorMessage: state.auth.errorMessage,
  successMessage: state.auth.successMessage,
  showLoading: state.auth.showLoading,
});

export default connect(mapStateToProps)(Login);
